import React from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'reactstrap';
import useService from '../../shared/hooks/useService';
import dashboardService from '../../services/dashboardService';
import { DropDown } from '../../shared/components';

interface Props {
  memberId: number;
  send: (type: string, rest?: Record<string, unknown>) => void;
}

const MembersDropDown: React.FC<Props> = ({ memberId, send }) => {
  const [members] = useService(dashboardService.members);
  const { t } = useTranslation();

  if (members === null) {
    return <Spinner />;
  }

  const membersList = members.map((x) => ({ id: x.id, text: x.name, htmlId: `m${x.id}` }));
  const setMember = (id: number) => send('MEMBER', { value: id });

  return (
    <>
      <h5 className="m-1">{t('teamMembers')}</h5>
      <DropDown txtSize={140} value={memberId} onChange={setMember} elements={membersList} />
    </>
  );
};

export default React.memo(
  MembersDropDown,
  (prevProps, nextProps) => prevProps.memberId === nextProps.memberId
);
